import { Component, ElementRef, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Modal Service
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
class ModalService {
    constructor() {
        this.modals = [];
    }
    /**
     * Add modal
     * @param {?} modal a modal
     * @return {?}
     */
    add(modal) {
        // add modal to array of active modals
        this.modals.push(modal);
    }
    /**
     * Remove modal
     * @param {?} id Id of modal
     * @return {?}
     */
    remove(id) {
        // remove modal from array of active modals
        /* tslint:disable:no-unused-expression*/
        this.modals = this.modals.filter((x) => {
            x.id !== id;
        });
    }
    /**
     * Open modal
     * @param {?} id Id of modal
     * @return {?}
     */
    open(id) {
        // open modal specified by id
        let /** @type {?} */ modal;
        /* tslint:disable: prefer-for-of */
        for (let /** @type {?} */ i = 0; i < this.modals.length; i++) {
            if (this.modals[i].id === id) {
                modal = this.modals[i];
            }
        }
        modal.open();
    }
    /**
     * Close modal
     * @param {?} id Id of modal
     * @return {?}
     */
    close(id) {
        // close modal specified by id
        let /** @type {?} */ modal;
        for (let /** @type {?} */ i = 0; i < this.modals.length; i++) {
            if (this.modals[i].id === id) {
                modal = this.modals[i];
            }
        }
        modal.close();
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(); };
ModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac });


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Modal component
 */
class ModalComponent {
    /**
     * @param {?} modalService
     * @param {?} el
     */
    constructor(modalService, el) {
        this.modalService = modalService;
        this.el = el;
        this.element = this.el.nativeElement;
        // this.setGreyOut();
    }
    /**
     * ng on init
     * @return {?}
     */
    ngOnInit() {
        const /** @type {?} */ modal = this;
        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }
        // move element to bottom of page (just before </body>)
        // so it can be displayed above everything else
        document.body.appendChild(this.element);
        // close modal on background click
        this.element.addEventListener('click', function (e) {
            if (e.target.className === 'sis-modal') {
                modal.close();
            }
        });
        // todo take grey out
        // add self (this modal instance) to the modal service
        // so it's accessible from controllers
        console.log('this', this);
        this.modalService.add(this);
        this.close(); // TODO fix me. its opening on init.
    }
    /**
     * ng on destroy
     * @return {?}
     */
    ngOnDestroy() {
        console.log('THIS IS RUNNING', this.id);
        this.modalService.remove(this.id);
        this.element.remove();
    }
    /**
     * Opens the modal
     * @return {?}
     */
    open() {
        this.element.style.display = 'block';
        document.body.classList.add('sis-modal-open');
    }
    /**
     * Closes modal
     * @return {?}
     */
    close() {
        this.element.style.display = 'none';
        document.body.classList.remove('sis-modal-open');
    }
}
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵngcc0.ɵɵdirectiveInject(ModalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["sis-modal"]], inputs: { id: "id", greyOut: "greyOut" }, ngContentSelectors: _c0, decls: 4, vars: 0, consts: [[1, "sis-modal"], [1, "sis-modal-body"], [1, "sis-modal-background"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(3, "div", 2);
    } }, styles: ["sis-modal[_ngcontent-%COMP%]{display:none}body.sis-modal-open[_ngcontent-%COMP%]{overflow:hidden}.sis-modal[_ngcontent-%COMP%]{width:560px;height:374px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:1000;overflow:auto}.sis-modal-body[_ngcontent-%COMP%]{padding:20px;background:#fff;margin:40px}.sis-modal-background[_ngcontent-%COMP%]{position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000;opacity:.75;z-index:900}"] });
/** @nocollapse */
ModalComponent.ctorParameters = () => [
    { type: ModalService },
    { type: ElementRef }
];
ModalComponent.propDecorators = {
    id: [{ type: Input }],
    greyOut: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'sis-modal',
                template: `<div class="sis-modal">
            <div class="sis-modal-body">
                <ng-content></ng-content>
            </div>
        </div>
        <div class="sis-modal-background"></div>`,
                styles: ["sis-modal{display:none}body.sis-modal-open{overflow:hidden}.sis-modal{width:560px;height:374px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:1000;overflow:auto}.sis-modal-body{padding:20px;background:#fff;margin:40px}.sis-modal-background{position:fixed;top:0;right:0;bottom:0;left:0;background-color:#000;opacity:.75;z-index:900}"]
            }]
    }], function () { return [{ type: ModalService }, { type: ɵngcc0.ElementRef }]; }, { id: [{
            type: Input
        }], greyOut: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class ModalModule$$1 {
}
ModalModule$$1.ɵfac = function ModalModule$$1_Factory(t) { return new (t || ModalModule$$1)(); };
ModalModule$$1.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ModalModule$$1 });
ModalModule$$1.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [ModalService], imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalModule$$1, [{
        type: NgModule,
        args: [{
                declarations: [ModalComponent],
                exports: [ModalComponent],
                imports: [],
                providers: [ModalService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule$$1, { declarations: [ModalComponent], exports: [ModalComponent] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { ModalService, ModalComponent, ModalModule$$1 as ModalModule };

